<template>
	<div class="d-flex gap-1">
		<select class="form-select form-select-sm w-auto" v-model="tipo" :disabled="disabled" @change="cambiaTipo">
			<option value="pg">Azienda</option>
			<option value="pf">Persona fisica</option>
		</select>
		<div class="flex-fill">
			<Select2 v-if="tipo == 'pg'" :modelValue="pg" @update:modelValue="(v) => aggiorna('pg', v)" load-on-open :api="apiAziende" :apiselected="'shared-s2/aziende/selected'" :placeholder="placeholder" :disabled="disabled"></Select2>
			<Select2 v-else :modelValue="pf" @update:modelValue="(v) => aggiorna('pf', v)" load-on-open :api="'shared-s2/persone-fisiche'" :apiselected="'shared-s2/persone-fisiche/selected'" :placeholder="placeholder" :disabled="disabled"></Select2>
		</div>
	</div>
</template>

<script>
import Select2 from '@/components/utils/Select2.vue'

// Select2 emette anche "_id" mentre risolve l'etichetta: qui conta solo il numero
const num = (v) => parseInt(String(v ?? '').replace(/_/g, '')) || 0;

// Intestatario come in TabDatiProgetto: azienda (ID_PERSONA_GIURIDICA) o persona fisica, mai entrambe
export default {
	name: 'SelectIntestatario',
	components: { Select2 },
	props: {
		pg: { type: [Number, String], default: 0 },
		pf: { type: [Number, String], default: 0 },
		apiAziende: { type: String, default: 'shared-s2/aziende' },
		placeholder: { type: String, default: 'Nessuno' },
		disabled: { type: Boolean, default: false }
	},
	emits: ['update:pg', 'update:pf', 'change'],
	data() {
		return { tipo: num(this.pf) > 0 ? 'pf' : 'pg' };
	},
	watch: {
		pg(v) { if (num(v) > 0) this.tipo = 'pg'; },
		pf(v) { if (num(v) > 0) this.tipo = 'pf'; }
	},
	methods: {
		cambiaTipo() {
			if (num(this.pg) == 0 && num(this.pf) == 0) return;
			this.$emit('update:pg', 0);
			this.$emit('update:pf', 0);
			this.$emit('change');
		},
		aggiorna(campo, v) {
			const prima = num(this[campo]);
			this.$emit('update:' + campo, v);
			if (num(v) != prima) this.$emit('change');
		}
	}
}
</script>
